import React from 'react'
import EmbeddedCheckoutForm from '../components/FormComponents/EmbeddedCheckoutForm'
import { Dialog } from '@mui/material'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const PaymentModal = ({ id, open, setPaymentModal, paymentIntentDetails, setOpen }) => {
    const navigate = useNavigate();
    
    const encodeUserId = (id) => {
        return btoa(id.toString())
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    };

    const handlePaymentComplete = () => {
        toast.success('Your Payment Was Successful');

        const encodedId = encodeUserId(id);
        navigate(`/user/${encodedId}`);
        setPaymentModal(false);
        setOpen(false);
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <Dialog PaperProps={{
                sx: (theme) => ({
                    borderRadius: {
                        xs: "10px",
                        sm: "15px",
                        md: "20px",
                    },
                    display: "flex",
                    padding: "20px",
                    flexDirection: "column",
                    height: "auto",
                }),
            }} open={open} onClose={handleClose} maxWidth="lg" fullWidth >
                <div>
                    <div className="flex justify-between items-center mb-4">
                        <span className="text-xl font-bold ">Make Your Payment</span>
                        <button onClick={handleClose}>
                            <IoIosCloseCircleOutline size={25} color="#777777" />
                        </button>
                    </div>
                    <div className="border"></div>
                </div>
                {paymentIntentDetails.clientSecret && <EmbeddedCheckoutForm clientSecret={paymentIntentDetails.clientSecret} handlePaymentComplete={handlePaymentComplete} />}
            </Dialog>
        </>
    )
}

export default PaymentModal